export const Cards = () => (
  <svg
    width="217"
    height="158"
    viewBox="0 0 217 158"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_207_3661)">
      <rect
        x="117.445"
        y="24.0808"
        width="64"
        height="80"
        rx="12"
        transform="rotate(15 117.445 24.0808)"
        fill="#454545"
      />
      <rect
        x="123.859"
        y="46.5051"
        width="40"
        height="40"
        rx="20"
        transform="rotate(15 123.859 46.5051)"
        fill="#777777"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M137.881 63.7209L139.296 66.1704L141.745 64.7562L147.541 66.3091L146.505 70.1728L143.349 70.3622L141.796 76.1578L132.137 73.5696L133.69 67.7741L131.051 66.0317L132.086 62.168L137.881 63.7209ZM140.192 70.5517C140.726 70.6947 141.274 70.3781 141.417 69.8446C141.56 69.3111 141.243 68.7628 140.71 68.6199C140.176 68.4769 139.628 68.7935 139.485 69.327C139.342 69.8604 139.659 70.4088 140.192 70.5517Z"
        fill="white"
      />
      <path
        d="M131.101 77.4333L131.619 75.5015L141.278 78.0897L140.761 80.0215L131.101 77.4333Z"
        fill="white"
      />
      <rect
        x="117.799"
        y="24.6932"
        width="63"
        height="79"
        rx="11.5"
        transform="rotate(15 117.799 24.6932)"
        stroke="#777777"
      />
    </g>
    <g filter="url(#filter1_d_207_3661)">
      <rect
        x="37.7383"
        y="40.645"
        width="64"
        height="80"
        rx="12"
        transform="rotate(-15 37.7383 40.645)"
        fill="#454545"
      />
      <rect
        x="54.5039"
        y="56.8577"
        width="40"
        height="40"
        rx="20"
        transform="rotate(-15 54.5039 56.8577)"
        fill="#777777"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M75.2526 64.7559L77.7021 66.1701L79.1163 63.7206L84.9118 62.1677L85.9471 66.0314L83.3082 67.7738L84.8611 73.5694L75.2018 76.1576L73.6489 70.362L70.4923 70.1725L69.457 66.3088L75.2526 64.7559ZM80.6692 69.5162C81.2027 69.3733 81.5193 68.8249 81.3763 68.2915C81.2334 67.758 80.685 67.4414 80.1516 67.5844C79.6181 67.7273 79.3015 68.2756 79.4445 68.8091C79.5874 69.3426 80.1357 69.6591 80.6692 69.5162Z"
        fill="white"
      />
      <path
        d="M76.2371 80.0213L75.7195 78.0894L85.3787 75.5012L85.8964 77.4331L76.2371 80.0213Z"
        fill="white"
      />
      <rect
        x="38.3507"
        y="40.9986"
        width="63"
        height="79"
        rx="11.5"
        transform="rotate(-15 38.3507 40.9986)"
        stroke="#777777"
      />
    </g>
    <g filter="url(#filter2_d_207_3661)">
      <rect x="77" y="21" width="64" height="80" rx="12" fill="#454545" />
      <rect x="89" y="41" width="40" height="40" rx="20" fill="#777777" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M107 54L109 56L111 54H117V58L114 59V65H104V59L101 58V54H107ZM111 60C111.552 60 112 59.5523 112 59C112 58.4477 111.552 58 111 58C110.448 58 110 58.4477 110 59C110 59.5523 110.448 60 111 60Z"
        fill="white"
      />
      <path d="M104 69V67H114V69H104Z" fill="white" />
      <rect
        x="77.5"
        y="21.5"
        width="63"
        height="79"
        rx="11.5"
        stroke="#777777"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_207_3661"
        x="56.7383"
        y="-3.91919"
        width="162.527"
        height="173.838"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="12" />
        <feGaussianBlur stdDeviation="20" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.137255 0 0 0 0 0.141176 0 0 0 0 0.160784 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_207_3661"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_207_3661"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_207_3661"
        x="-2.26172"
        y="-3.91943"
        width="162.523"
        height="173.839"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="12" />
        <feGaussianBlur stdDeviation="20" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.137255 0 0 0 0 0.141176 0 0 0 0 0.160784 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_207_3661"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_207_3661"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d_207_3661"
        x="37"
        y="-7"
        width="144"
        height="160"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="12" />
        <feGaussianBlur stdDeviation="20" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.137255 0 0 0 0 0.141176 0 0 0 0 0.160784 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_207_3661"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_207_3661"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
